import React from 'react';
import { Hero } from '../components/Hero';
import { MetricsBar } from '../components/MetricsBar';
import { TrustStrip } from '../components/TrustStrip';
import { AboutNarrative } from '../components/AboutNarrative';
import { BoardModule } from '../components/BoardModule';
import { ExpertiseGrid } from '../components/ExpertiseGrid';
import { CaseStudies } from '../components/CaseStudies';
import { ApproachSteps } from '../components/ApproachSteps';
import { CareerTimeline } from '../components/CareerTimeline';
import { Recognition } from '../components/Recognition';
import { SkillsCloud } from '../components/SkillsCloud';
import { Credentials } from '../components/Credentials';
import { ContactSection } from '../components/ContactSection';
export function Home() {
  return <>
      <Hero data-id="element-470" data-mp="3kvk5ok4kl15z" />
      <MetricsBar data-id="element-471" data-mp="3kvtmpi7mzxzj" />
      <TrustStrip data-id="element-472" data-mp="3ku8tpx0z0n3s" />
      <AboutNarrative data-id="element-473" data-mp="3kuqzbk9iwdod" />
      <BoardModule data-id="element-474" data-mp="3kxmskvafee6h" />
      <ExpertiseGrid data-id="element-475" data-mp="3owlwcckf84wc" />
      <CaseStudies data-id="element-476" data-mp="3ovub9vog9pkb" />
      <ApproachSteps data-id="element-477" data-mp="3ovare9f8or3n" />
      <CareerTimeline data-id="element-478" data-mp="3oyymhd0c1lkh" />
      <Recognition data-id="element-479" data-mp="30wjcmpo0ou4v" />
      <SkillsCloud data-id="element-480" data-mp="30x1h29ku2env" />
      <Credentials data-id="element-481" data-mp="30vgogpi2x5sn" />
      <ContactSection data-id="element-482" data-mp="30w03nygchg2z" />
    </>;
}